// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"266":"fc1fbe0c","523":"bdc66c9c","640":"1497644f","852":"eb03dd60","945":"49013169","986":"f6acbc8d"}[chunkId] + ".chunk.js";
};